// extracted by mini-css-extract-plugin
module.exports = {"trending":"styles_trending__NGoca"};